var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDstndevlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "58.000000pt",
    viewBox: "0 0 300.000000 58.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,58.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550 537 c-3 -3 -27 -7 -55 -10 -109 -12 -251 -49 -320 -84 -80 -41 -152 -130 -127 -155 7 -7 17 2 31 29 26 53 77 90 170 124 118 45 218 61 416 66 325 9 572 -47 663 -152 54 -61 37 -118 -53 -170 -40 -24 -134 -61 -180 -72 -61 -13 -192 -32 -272 -38 l-92 -7 -3 108 c-4 144 -22 144 -26 0 -4 -140 -3 -140 103 -131 180 16 194 18 298 44 113 29 188 66 238 117 37 37 44 51 44 84 0 107 -165 197 -430 237 -46 7 -399 16 -405 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200 537 c-3 -2 -41 -8 -85 -11 -98 -8 -113 -10 -195 -29 -181 -43 -305 -127 -305 -206 0 -135 265 -245 595 -246 l95 0 0 118 c0 73 -4 116 -10 115 -6 -2 -11 -47 -12 -107 l-1 -104 -52 0 c-175 2 -372 43 -487 102 -48 24 -103 84 -103 112 0 67 75 125 220 169 138 42 233 54 430 53 312 0 524 -57 613 -163 15 -17 27 -38 27 -46 0 -8 7 -14 16 -14 27 0 7 50 -38 97 -56 57 -208 117 -348 139 -102 15 -352 30 -360 21z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDstndevlogo);
export default __webpack_public_path__ + "static/media/dstndevlogo.f01467efabbf7bb3b0d0baceeaae7dcf.svg";
export { ForwardRef as ReactComponent };